export default "__VITE_ASSET__xK1pRhZk__"